import React, { useState, useEffect, useMemo, useContext } from "react";
import { useNavigate } from "react-router";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  CLAIM_TYPE_OPTIONS,
  DELIVERED_SERVICE_STATUS_OPTIONS,
  DUMMY_ADD_SERVICE_PROVIDER_VALUE,
  CASE_NOTES_TIME_VALUES,
  REGEX_HHH_MM,
} from "Constants/constant";
import { caseNotesCreateRequest } from "store/actions/ah.actions";
import api from "store/services/ah.services";
import { LOADER_STATUS } from "store/constants";
import SelectOption from "components/common/Select/Select";
import MultiFileInput from "components/common/FileUpload/MultiFileInput";
import CheckBox from "components/common/checkBox/checkbox";
import Loader from "components/common/Loader/Loader";
import TextEditor from "components/common/TextEditor/TextEditor";
import { caseNoteHoursAmount, gethoursAndMins } from "Utils/utils";
import {
  getDefaultDeliveredDate,
  getFundingDeliveredDatePickerBounds,
} from "Utils/fundingDeliveredDateBounds";
import {
  applyCaseNoteRatioAmount,
  CASE_NOTE_RATIO_OPTIONS,
  formatCaseNoteSupportItemFullLabel,
  mapCaseNoteSupportItemOptions,
  normalizeCaseNoteRatio,
} from "Utils/caseNoteSupportItem";
import { uploadFilesOnVapour } from "Utils/uploadFileOnS3";
import { LoginContext } from "helpers/LoginContext";
import { toast } from "react-toastify";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BiCalendar } from "react-icons/bi";

const DEFAULT_CLAIM_TYPE = CLAIM_TYPE_OPTIONS.find((o) => o.value === "STAND");

const CreateCaseNotesModal = (props) => {
  const {
    ContactList,
    getContactListRequest,
    caseNotesCreateLoading,
    SupportItems,
    // isOpen,
    // closeModal,
    selectedFunding,
    cosParticipantsProfile,
    selectedServiceSupport,
    setSelectedServiceSupport,
    singleSupportTrackLoading,caseNoteerror
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isUserGracePeriodOver } = useContext(LoginContext);

  const [cosParticipantState, setCosParticipantState] = useState(null);
  const [selectedExternalSp, setSelectedExternalSp] = useState(null);
  const [selectedServiceProvider, setSelectedServiceProvider] = useState({
    name: "",
    id: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [remAmount, setRemAmount] = useState(0.0);
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [serviceSupportId, setServiceId] = useState(null);
  const [serviceTimeEntered, setServiceTimeEntered] = useState();
  const [contractType, setContractType] = useState(null);
  const [isBillabel, setIsBillabel] = useState(true);
  const [externalSpFetchRequest, setExternalSpFetchRequest] = useState(false);
  const [externalSpOptions, setExternalSpOptions] = useState([]);
  const [pricePerMinute, setPricePerMinute] = useState(0);
  const [claimType, setClaimType] = useState(DEFAULT_CLAIM_TYPE);
  const [ratio, setRatio] = useState(CASE_NOTE_RATIO_OPTIONS[0]);
  const [calculatedPrice, setCalculatedPrice] = useState(0);
  const [isCreateCaseNoteLoader, setIsCreateCaseNoteLoader] = useState(
    LOADER_STATUS.NA
  );
  const [km, setKm] = useState("");
  const [deliveredDate, setDeliveredDate] = useState(null);

  const {
    register,
    handleSubmit,
    clearErrors,
    formState: { errors },
    setValue,
    watch,
    reset,
  } = useForm();

  const watchFormData = watch();

  const currentSelectedSupportItem = useMemo(() => {
    if (selectedServiceSupport && SupportItems && SupportItems.length > 0) {
      const item = SupportItems.find(
        (x) => x.uuid === selectedServiceSupport.uuid
      );
      return item ? item : selectedServiceSupport;
    }
  }, [SupportItems, selectedServiceSupport]);

  const deliveredDatePickerBounds = useMemo(
    () => getFundingDeliveredDatePickerBounds(selectedFunding),
    [selectedFunding]
  );
  const selectedRatioValue =
    claimType?.value === "TRAVEL"
      ? normalizeCaseNoteRatio(ratio?.value)
      : "Standard";

  const supportItemsOptions = useMemo(
    () => mapCaseNoteSupportItemOptions(SupportItems, claimType?.value),
    [SupportItems, claimType]
  );

  const supportItemSelectOption = useMemo(() => {
    if (!currentSelectedSupportItem) return null;
    const pc = currentSelectedSupportItem?.price_catalog;
    return {
      ...currentSelectedSupportItem,
      value: currentSelectedSupportItem?.id,
      label: formatCaseNoteSupportItemFullLabel(
        pc?.support_item_number,
        pc?.support_item_name,
        claimType?.value
      ),
    };
  }, [currentSelectedSupportItem, claimType]);

  useEffect(() => {
    handleCancelCaseNote({ preserveClaimType: true });
  }, [selectedServiceSupport]);

  const handleCancelCaseNote = ({ preserveClaimType = false } = {}) => {
    const defaultDeliveredDate = getDefaultDeliveredDate(
      deliveredDatePickerBounds
    );
    const claimTypeForForm = preserveClaimType ? claimType : DEFAULT_CLAIM_TYPE;

    if (currentSelectedSupportItem) {
      reset({
        service_support_id: currentSelectedSupportItem?.id,
        totalAmount: "$0",
        delivered_date: defaultDeliveredDate,
        note: null,
        subject: null,
        Hours: null,
        km: "",
        attachments: [],
      });
      handleChangeSupportItems({
        ...currentSelectedSupportItem,
        value: currentSelectedSupportItem?.id,
        label: formatCaseNoteSupportItemFullLabel(
          currentSelectedSupportItem?.price_catalog?.support_item_number,
          currentSelectedSupportItem?.price_catalog?.support_item_name,
          claimTypeForForm?.value
        ),
      });
    }

    setKm("");
    if (!preserveClaimType) {
      setClaimType(DEFAULT_CLAIM_TYPE);
      setValue("claim_type", DEFAULT_CLAIM_TYPE);
    } else if (claimType) {
      setValue("claim_type", claimType);
    }
    setDeliveredDate(defaultDeliveredDate);
    setValue("delivered_date", defaultDeliveredDate);
    if (!preserveClaimType) {
      setContractType(null);
    }
    setIsBillabel(true);
    setIsSubmitting(false);
    // setHours("");
  };

  useEffect(() => {
    if (remainingAmount >= 0) {
      clearErrors("remainingamount");
    }

    setValue(
      "remainingamount",
      remainingAmount > 0 ? parseFloat(remainingAmount).toFixed(2) : 0
    );
  }, [remainingAmount]);

  useEffect(() => {
    getContactListRequest({ status: "active" });
    getEXternalSpSearchList();
  }, []);

  useEffect(() => {
    if (
      !caseNotesCreateLoading &&
      currentSelectedSupportItem &&
      isCreateCaseNoteLoader !== LOADER_STATUS.PENDING
    ) {
      handleChangeSupportItems({
        ...currentSelectedSupportItem,
        value: currentSelectedSupportItem?.id,
        label: formatCaseNoteSupportItemFullLabel(
          currentSelectedSupportItem?.price_catalog?.support_item_number,
          currentSelectedSupportItem?.price_catalog?.support_item_name,
          claimType?.value
        ),
      });
    }
  }, [currentSelectedSupportItem, claimType]);

  useEffect(() => {
    if (
      !caseNotesCreateLoading &&
      isCreateCaseNoteLoader === LOADER_STATUS.PENDING &&
      isCreateCaseNoteLoader !== LOADER_STATUS.NA
    ) {
      setIsCreateCaseNoteLoader(LOADER_STATUS.COMPLETE);
    }
  }, [caseNotesCreateLoading]);

  useEffect(() => {
    if (
      !caseNotesCreateLoading &&
      isCreateCaseNoteLoader === LOADER_STATUS.COMPLETE 
      && !caseNoteerror
    ) {
      setIsCreateCaseNoteLoader(LOADER_STATUS.NA);
      handleCancelCaseNote();
    }
  }, [isCreateCaseNoteLoader, caseNotesCreateLoading]);

  useEffect(() => {
    if (contractType) {
      setValue("contract_type", contractType);
      clearErrors("contract_type");
    }
    if (isBillabel) {
      setValue("bill_types", isBillabel);
      clearErrors("bill_types");
    }
  }, [contractType, isBillabel]);

  useEffect(() => {
    if (claimType) {
      setValue("claim_type", claimType);
      clearErrors("claim_type");
    }
  }, [claimType]);

  useEffect(() => {
    if (claimType?.value === "TRAVEL") {
      setRatio((prev) => prev ?? CASE_NOTE_RATIO_OPTIONS[0]);
    } else {
      setRatio(CASE_NOTE_RATIO_OPTIONS[0]);
    }
  }, [claimType]);

  useEffect(() => {
    if (km) {
      setValue("km", km);
      clearErrors("km");
    }
  }, [km]);

  useEffect(() => {
    register("delivered_date", { required: true });
    register("note", { required: true });
  }, [register]);

  const onSubmit = async (data, event) => {
    if (isUserGracePeriodOver || isSubmitting) return;
    if (event?.key === "Enter") {
      event.preventDefault();
      return;
    }
    const formData = new FormData();

    if (selectedExternalSp?.value) {
      formData.append("external_sp_id", selectedExternalSp.value);
    }
    if (cosParticipantState) {
      formData.append("state_id", cosParticipantState.id);
    }

    if (claimType) {
      formData.append("claim_type", claimType.label);
    }
    if (claimType?.value === "TRAVEL") {
      formData.append("ratio", selectedRatioValue);
    }
    if (data.delivered_date) {
      const formattedDate = moment(data.delivered_date).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      formData.append("delivered_date", formattedDate);
    }
    if (data.delivered_from) {
      formData.append("delivered_from", data.delivered_from);
    }
    if (data.delivered_to) formData.append("delivered_to", data?.delivered_to);
    formData.append("delivered_quantity", serviceTimeEntered || "00:00");
    formData.append("funding_id", selectedFunding.uuid);
    formData.append("subject", data?.subject);
    formData.append("notes", data?.note);
    // formData.append("provider_invoice_date", data?.provider_invoice_date);
    // formData.append("provider_invoice_number", data?.provider_invoice_number);
    formData.append("pt_id", cosParticipantsProfile.id);
    formData.append("cos_contact_type_id", contractType?.id || "");
    formData.append("service_support_id", serviceSupportId);
    formData.append("status", DELIVERED_SERVICE_STATUS_OPTIONS[9].value);
    formData.append(
      "total_amount",
        isBillabel ? Number(calculatedPrice || 0).toFixed(2) : 0
    );
    formData.append(
      "bill_types",
      isBillabel ? "billable_hours" : "non_billable_hour"
    );
    if (km) {
      formData.append("km", km);
    }

    const fileToUpload =
      data?.attachments?.filter((fl) => fl instanceof File) || [];

    if (fileToUpload.length > 0) {
      setIsSubmitting(true);
      try {
        const uploadResults = await uploadFilesOnVapour(fileToUpload);
        const preparFilesData = (uploadResults || [])
          .filter((item) => item?.key)
          .map((item) => ({
            key: item.key,
            ext: item.ext,
            name: item.name,
          }));

        if (preparFilesData.length !== fileToUpload.length) {
          toast.error("Failed to upload one or more attachments. Please try again.");
          setIsSubmitting(false);
          return;
        }

        preparFilesData.forEach((file, index) => {
          formData.append(`attachments[${index}][key]`, file.key);
          formData.append(`attachments[${index}][ext]`, file.ext);
          formData.append(`attachments[${index}][name]`, file.name);
        });
      } catch (error) {
        console.error("Attachment upload failed:", error);
        toast.error("Failed to upload attachments. Please try again.");
        setIsSubmitting(false);
        return;
      }
      setIsSubmitting(false);
    }

    dispatch(caseNotesCreateRequest({ formData }));
    setIsCreateCaseNoteLoader(LOADER_STATUS.PENDING);
  };

  const getEXternalSpSearchList = async () => {
    try {
      setExternalSpFetchRequest(true);
      const response = await api.getServiceProviderSearchList({ name: "" });
      if (response && response.external_sps) {
        setExternalSpFetchRequest(false);
        const data = response.external_sps.map((x) => {
          const obj = { ...x, label: x.name, value: x.id };
          return { ...obj };
        });
        data.unshift({
          value: "add_service_provider",
          label: "Add New Service Provider",
        });
        setExternalSpOptions([...data]);
        return [...data];
      }
      setExternalSpFetchRequest(false);

      setExternalSpOptions([]);
    } catch (err) {
      console.log("err", err);
      setExternalSpFetchRequest(false);
    }
  };

  const handleChangeSupportItems = (e) => {
    setValue("totalAmount", "$0");
    setCalculatedPrice(0);
    const lineItemExternalSp =
      e.external_service_provider || e.external_sp || null;
    if (lineItemExternalSp) {
      const selectedSp = {
        label: lineItemExternalSp.name,
        value: lineItemExternalSp.id,
      };
      setSelectedExternalSp(selectedSp);
      setSelectedServiceProvider(selectedSp);
    } else {
      setSelectedExternalSp(null);
      setSelectedServiceProvider({
        label: "",
        value: "",
      });
    }
    setCosParticipantState(e.state);
    setRemAmount(e.remain_amount);
    setRemainingAmount(
      parseFloat(e.amount_allocated || 0) ===
        parseFloat(e.remain_amount || 0) &&
        parseFloat(e.delivered_amount || 0) === 0
        ? parseFloat(e.total_budget_amount)
        : parseFloat(e.remain_amount || 0)
    );
    setServiceId(e.id);
    if (e.value) {
      setServiceId(e.id);
      if (e.alternative_rate && parseFloat(e.alternative_rate) > 0) {
        setPricePerMinute(parseFloat(e?.alternative_rate) / 60);
      } else {
        setPricePerMinute(parseFloat(e?.original_rate) / 60);
      }
      setValue("service_support_id", e);
      clearErrors("service_support_id");
    }
  };

  const handleHoursInputOnChange = (inputValue) => {
    if (inputValue && REGEX_HHH_MM.test(inputValue)) {
      // setHours(inputValue);
      const [hours] = inputValue.split(":").map(Number);

      // Ensure hours do not exceed 24
      if (hours > 24) {
        setValue("totalAmount", "$0");
        setCalculatedPrice(0);
        setRemainingAmount(remAmount);
        return;
      }
      clearErrors("Hours");
      const valueEntered = inputValue;
      setServiceTimeEntered(valueEntered);
      const lineTotal = applyCaseNoteRatioAmount(
        caseNoteHoursAmount(valueEntered, pricePerMinute * 60),
        selectedRatioValue
      );
      setValue("totalAmount", `$${lineTotal.toFixed(2)}`);
      setCalculatedPrice(lineTotal);

      if (lineTotal > 0) {
        if (
          inputValue.toString() ===
          gethoursAndMins(
            currentSelectedSupportItem.remain_total_hours,
            currentSelectedSupportItem.remain_total_mint
          )
        ) {
          const fullFinal = applyCaseNoteRatioAmount(remAmount, selectedRatioValue);
          setCalculatedPrice(fullFinal);
          setRemainingAmount(isBillabel ? Math.max(parseFloat(remAmount) - fullFinal, 0) : remAmount);
          setValue("totalAmount", `$${fullFinal.toFixed(2)}`);
        } else {
          setCalculatedPrice(lineTotal);
          setRemainingAmount(
            isBillabel
              ? Math.max(parseFloat(remAmount) - lineTotal, 0)
              : remAmount
          );
        }
      } else {
        // If non-billable, do not deduct from remaining amount
        setCalculatedPrice(0);
        setRemainingAmount(remAmount); // Ensure this is a number
      }
    } else {
      setValue("totalAmount", "$0");
      setCalculatedPrice(0);
      setRemainingAmount(remAmount); // Ensure this is a number
    }
  };

  const handleKmInputOnChange = (inputValue) => {
    if (inputValue === "") {
      setKm(""); // Ensure it clears completely
      setValue("km", ""); // Update form state
      setValue("totalAmount", "$0");
      setCalculatedPrice(0);
      setRemainingAmount(remAmount);
      return;
    }

    if (/^\d*\.?\d*$/.test(inputValue)) {
      // Allow empty input for backspace
      clearErrors("km");
      const valueEntered = parseFloat(inputValue);
      setKm(valueEntered);

      // Calculate total amount based on km
      const totalAmount = 1 * valueEntered;
      const finalAmount = applyCaseNoteRatioAmount(totalAmount, selectedRatioValue);
      setCalculatedPrice(finalAmount);
      setValue("totalAmount", `$${finalAmount.toFixed(2)}`);

      if (finalAmount > 0) {
        // Update remaining amount
        const ttlRem = parseFloat(remAmount) - finalAmount;
        setRemainingAmount(ttlRem > 0.0 ? ttlRem : 0.0);
      } else {
        setRemainingAmount(remAmount);
      }
    } else {
      setValue("totalAmount", "$0");
      setCalculatedPrice(0);
      setRemainingAmount(remAmount);
    }
  };

  const validateTime = useMemo(() => {
    if (watchFormData?.Hours && currentSelectedSupportItem) {
      const typedHrMin = watchFormData?.Hours.toString().split(":");
      const srHrMin = gethoursAndMins(
        currentSelectedSupportItem.remain_total_hours,
        currentSelectedSupportItem.remain_total_mint
      ).split(":");
      if (
        parseInt(typedHrMin[0]) === parseInt(srHrMin[0]) &&
        parseInt(typedHrMin[1]) === parseInt(srHrMin[1])
      ) {
        clearErrors("Hours");
        return true;
      } else if (parseInt(typedHrMin[0]) > parseInt(srHrMin[0])) {
        return false;
      } else if (
        parseInt(typedHrMin[0]) === parseInt(srHrMin[0]) &&
        parseInt(typedHrMin[1]) > parseInt(srHrMin[1])
      ) {
        return false;
      }
    }
    clearErrors("Hours");
    return true;
  }, [watchFormData?.Hours]);

  useEffect(() => {
    if (currentSelectedSupportItem?.unit !== "H") return;
    if (watchFormData?.Hours && validateTime) {
      handleHoursInputOnChange(watchFormData.Hours);
    }
  }, [watchFormData?.Hours, currentSelectedSupportItem?.unit, validateTime]);

  useEffect(() => {
    const unit = currentSelectedSupportItem?.unit;
    if (unit === "E" && km !== "" && km !== null && Number(km) > 0) {
      handleKmInputOnChange(String(km));
      return;
    }
    if (unit === "H" && watchFormData?.Hours && validateTime) {
      handleHoursInputOnChange(watchFormData.Hours);
      return;
    }
    if (km !== "" && km !== null && Number(km) > 0) {
      handleKmInputOnChange(String(km));
    }
  }, [
    selectedRatioValue,
    claimType?.value,
    currentSelectedSupportItem?.unit,
    validateTime,
  ]);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='grid grid-cols-3 gap-4 px-3'>
          <div className='col-span-1 flex flex-col gap-4'>
            <div>
              <div className='hidden'>
                <select
                  {...register("service_support_id", {
                    required: true,
                  })}
                  name='service_support_id'
                  id='service_support_id'
                  // htmlFor="service_support_id"
                  className='hidden did-floating-input'
                />
              </div>
              <label className='did-floating-label text-start mt-1'>
                Support Items
              </label>
              <SelectOption
                selectedOption={supportItemSelectOption}
                name='service_support_id'
                isSearch={false}
                data={supportItemsOptions}
                handleChange={(e) => {
                  setSelectedServiceSupport({ ...e, value: e.uuid });
                }}
                placeHolder={singleSupportTrackLoading ? "Loading..." : ""}
                loading={singleSupportTrackLoading}
              />
              {errors?.service_support_id?.type === "required" && (
                <span className='text-sm text-red-500'>
                  This field is required
                </span>
              )}
            </div>
            {claimType?.value === "TRAVEL" && (
              <div>
                <div className='hidden'>
                  <input
                    {...register("serviceProvider")}
                    name='price_catalog_id'
                  />
                </div>
                <label className='text-start did-floating-label'>
                  Service Provider
                </label>
                <SelectOption
                  isClearable
                  isSearch={true}
                  data={
                    externalSpOptions && externalSpOptions.length > 0
                      ? externalSpOptions
                      : []
                  }
                  selectedOption={selectedExternalSp}
                  handleChange={(e) => {
                    if (!e) {
                      setSelectedExternalSp(null);
                      setSelectedServiceProvider({ label: "", value: "" });
                      return;
                    }
                    if (e.value === DUMMY_ADD_SERVICE_PROVIDER_VALUE) {
                      navigate("/ah/external-service-provider");
                    } else {
                      setSelectedExternalSp(e);
                      setSelectedServiceProvider(e);
                    }
                  }}
                  loading={externalSpFetchRequest}
                  isDisabled={externalSpFetchRequest}
                />
              </div>
            )}
          </div>
          <div className='col-span-2'>
            <div className='grid grid-cols-3 gap-4 px-3'>
              <div className='col-span-1'>
                <div className='hidden'>
                  <select
                    {...register("claim_type", {
                      required: true,
                    })}
                    name='claim_type'
                    id='claim_type'
                    className='hidden did-floating-input'
                  />
                </div>
                <div className='text-start'>
                  <label htmlFor='claim_type' className='did-floating-label '>
                    Claim Type
                  </label>
                </div>
                <SelectOption
                  isSearch={false}
                  data={CLAIM_TYPE_OPTIONS}
                  selectedOption={claimType}
                  handleChange={setClaimType}
                  // placeHolder="Select Claim Type..."
                />
                {errors?.claim_type?.type === "required" && (
                  <span className='text-sm text-red-500'>
                    This field is required
                  </span>
                )}
              </div>
              {claimType?.value === "TRAVEL" && (
                <div className='col-span-1'>
                  <div className='hidden'>
                    <select {...register("ratio")} name='ratio' id='ratio' className='hidden did-floating-input' />
                  </div>
                  <div className='text-start'>
                    <label htmlFor='ratio' className='did-floating-label '>
                      Ratio
                    </label>
                  </div>
                  <SelectOption
                    isSearch={false}
                    data={CASE_NOTE_RATIO_OPTIONS}
                    selectedOption={ratio}
                    handleChange={setRatio}
                  />
                </div>
              )}
              <div className='col-span-1'>
                <label
                  htmlFor='delivered_date'
                  className='text-start did-floating-label'
                >
                  Delivered Date
                </label>
                <div className='relative'>
                  <ReactDatePicker
                    selected={deliveredDate}
                    onChange={(date) => {
                      setDeliveredDate(date);
                      setValue("delivered_date", date); // react-hook-form setValue
                    }}
                    dateFormat='dd/MM/yyyy'
                    placeholderText='Select a date'
                    className='did-floating-input pr-10' // Right padding for icon
                    calendarStartDay={1}
                    minDate={deliveredDatePickerBounds.minDate}
                    maxDate={deliveredDatePickerBounds.maxDate}
                  />
                  <BiCalendar
                    className='absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none'
                    size={20}
                  />
                </div>
                {errors?.delivered_date?.type === "required" && (
                  <span className='text-sm text-red-500'>
                    This field is required!
                  </span>
                )}
              </div>
              {claimType?.value !== "TRAVEL" && (
                <div className='col-span-1'>
                  <div className='hidden'>
                    <input
                      {...register("serviceProvider")}
                      name='price_catalog_id'
                    />
                  </div>
                  <label className='text-start did-floating-label'>
                    Service Provider
                  </label>
                  <SelectOption
                    isClearable
                    isSearch={true}
                    data={
                      externalSpOptions && externalSpOptions.length > 0
                        ? externalSpOptions
                        : []
                    }
                    selectedOption={selectedExternalSp}
                    handleChange={(e) => {
                      if (!e) {
                        setSelectedExternalSp(null);
                        setSelectedServiceProvider({ label: "", value: "" });
                        return;
                      }
                      if (e.value === DUMMY_ADD_SERVICE_PROVIDER_VALUE) {
                        navigate("/ah/external-service-provider");
                      } else {
                        setSelectedExternalSp(e);
                        setSelectedServiceProvider(e);
                      }
                    }}
                    loading={externalSpFetchRequest}
                    isDisabled={externalSpFetchRequest}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='hr width-full col-span-3 border-b border-b-gray-200 mt-4 mb-3'></div>
        <div className='grid grid-cols-3 gap-4 px-3'>
          <div className='col-span-1'>
            <div className='hidden'>
              <select
                {...register("contract_type", {
                  required: true,
                })}
                name='contract_type'
                id=''
                className='hidden did-floating-input'
              />
            </div>
            <label htmlFor='contract_type' className='did-floating-label '>
              Contact Type
            </label>
            <SelectOption
              isSearch={false}
              name='contract_type'
              data={ContactList}
              selectedOption={contractType}
              handleChange={setContractType}
              // placeHolder="Contract Type"
            />
            {errors?.contract_type?.type === "required" && (
              <span className='text-sm text-red-500'>
                This field is required!
              </span>
            )}
          </div>
          <div className='col-span-1'>
            <label htmlFor='' className=' text-start did-floating-label'>
              Subject
            </label>
            <input
              {...register("subject", {
                required: true,
                maxLength: 254,
              })}
              // value={participantStateId.name}
              name='subject'
              id='subject'
              type='text'
              // placeholder="Subject..."
              className='did-floating-input'
            />
            {errors?.subject?.type === "required" && (
              <span className='text-sm text-red-500'>
                This field is required!
              </span>
            )}
          </div>
          <div className='col-span-1'>
            <div className='hidden'>
              <input
                {...register("bill_types", {
                  required: true,
                })}
                name='bill_types'
                id=''
                className='hidden did-floating-input'
              />
            </div>
            <label htmlFor='' className='did-floating-label '>
              Is Billable
            </label>
            <div className='flex gap-4 justify-start'>
              <div className='flex gap-x-2 items-center'>
                <CheckBox
                  name='bill_types'
                  label='Billable'
                  checked={isBillabel}
                  handleChange={() => setIsBillabel(!isBillabel)}
                />
              </div>
              <div className='flex gap-x-2 items-center'>
                <CheckBox
                  name='bill_types'
                  label='Non-Billable'
                  checked={!isBillabel}
                  handleChange={() => setIsBillabel(!isBillabel)}
                />
              </div>
              {errors?.bill_types?.type === "required" && (
                <span className='text-sm text-red-500'>
                  This field is required!
                </span>
              )}
            </div>
          </div>
        </div>
        <div className='hr width-full col-span-3 border-b border-b-gray-200 mt-4 mb-3'></div>
        <div className='grid grid-cols-3 gap-4 px-3 items-start'>
          <div className='col-span-2 flex flex-col gap-4'>
            <div className='grid grid-cols-3 gap-4'>
              {/* <div className='col-span-1'>
                <label className='text-gray-700 text-sm font-medium mb-1'>
                  Hours
                </label>
 
                <input
                  {...register("Hours", { required: true })}
                  name='Hours'
                  isSearch={false}
                  data={CASE_NOTES_TIME_VALUES}
                  selectedOption={
                    watchFormData?.Hours
                      ? CASE_NOTES_TIME_VALUES.find(
                        (x) => x.value === watchFormData?.Hours
                      )
                      : null
                  }
                  errorMessage={
                    errors?.Hours?.type === "required" ? (
                      <span className='text-sm text-red-500'>
                        This field is required!
                      </span>
                    ) : errors?.Hours?.type === "validate" ? (
                      <span className='text-sm text-red-500'>
                        Hours should be Equal or less than Time Left
                      </span>
                    ) : null
                  }
                />
              </div> */}
              <div className='col-span-1'>
                <label className='text-gray-700 text-sm font-medium mb-1'>
                  {currentSelectedSupportItem?.unit === "E"
                    ? "Kilometers"
                    : "Hours"}
                </label>
                {currentSelectedSupportItem?.unit === "E" ? (
                  <div>
                    <input
                      {...register("km", {
                        required: "This field is required!",
                        min: {
                          value: 0,
                          message: "Km must be a positive number",
                        },
                      })}
                      name='km'
                      id='km'
                      type='number'
                      step='0.01' // Allows decimal input
                      value={km || ""} // Ensure km is not undefined
                      onChange={(e) => {
                        const value = e.target.value;
                        handleKmInputOnChange(value); // Call the function
                        setValue("km", value, { shouldValidate: true }); // Update react-hook-form and trigger validation
                      }}
                      className='did-floating-input'
                    />
                    {errors?.km && (
                      <span className='text-sm text-red-500'>
                        {errors.km.message}
                      </span>
                    )}
                  </div>
                ) : (
                  <>
                    <input
                      {...register("Hours", {
                        required: "This field is required!",
                        validate: (value) => {
                          if (!/^\d{1,2}:\d{2}$/.test(value)) {
                            return "The format should be HH:MM"; // Ensures format check first
                          }

                          const [hours, minutes] = value.split(":").map(Number);

                          if (hours > 24) {
                            return "Hours should not be more than 24";
                          }

                          if (minutes > 59) {
                            return "Minutes should not exceed 59";
                          }

                          return true;
                        },
                      })}
                      name='Hours'
                      type='text'
                      placeholder='HH:MM'
                      className='did-floating-input'
                      onChange={(e) => {
                        const value = e.target.value;
                        setValue("Hours", value, { shouldValidate: true });
                        handleHoursInputOnChange(value);
                      }}
                    />
                    {errors?.Hours && (
                      <span className='text-sm text-red-500'>
                        {errors.Hours.message}
                      </span>
                    )}
                  </>
                )}
              </div>

              <div className='col-span-1'>
                <label htmlFor='' className=' text-start did-floating-label'>
                  Total Amount
                </label>
                <input
                  {...register("totalAmount", {
                    required: true,
                    disabled: true,
                    // value: calculatedPrice
                    //   ? `$${parseFloat(calculatedPrice).toFixed(2)}`
                    //   : "$0",
                  })}
                  // defaultValue={parseFloat(calculatedPrice).toFixed(2)}
                  // placeholder="$0.00"
                  name='totalAmount'
                  type='text'
                  className='did-floating-input'
                  style={{
                    backgroundColor: "#4b6bb710",
                  }}
                />
              </div>
              <div className='col-span-1'>
                <label htmlFor='' className='text-start did-floating-label'>
                  Remaining Amount
                </label>
                <input
                  {...register("remainingamount")}
                  value={
                    !isNaN(parseFloat(remainingAmount))
                      ? `$${parseFloat(remainingAmount).toFixed(2)}`
                      : "$0.00"
                  }
                  // pattern="^\d*(\.\d{0,2})?$"
                  disabled
                  name='remainingamount'
                  type='text'
                  className='did-floating-input'
                  style={{
                    backgroundColor: "#4b6bb710",
                  }}
                />
              </div>
            </div>
            <div>
              <label htmlFor='' className='did-floating-label text-start'>
                Case Notes
              </label>
              <TextEditor
                text={watchFormData?.note || ""}
                setText={(data) => setValue("note", data, { shouldValidate: true })}
              />
              {errors?.note?.type === "required" && (
                <span className='text-sm text-red-500'>
                  This field is required!
                </span>
              )}
            </div>
          </div>
          <div className='col-span-1 flex flex-col gap-4'>
            <div>
              <label htmlFor='' className='did-floating-label text-start'>
                Attachment
              </label>
              <div>
                <MultiFileInput
                  type='any'
                  filenameLimit={150}
                  maxFilesAllow={5}
                  handleFile={(e) => setValue("attachments", e)}
                  size={10}
                  files={watchFormData?.attachments}
                  handleDelete={(e) => setValue("attachments", e)}
                  showDragAndDrop={false}
                  setIsSubmitting={setIsSubmitting}
                  isHardClearAllStates={
                    isCreateCaseNoteLoader === LOADER_STATUS.COMPLETE
                  }
                />
              </div>
            </div>
            <div>
              <button
                type='submit'
                disabled={
                  caseNotesCreateLoading ||
                  singleSupportTrackLoading ||
                  isUserGracePeriodOver ||
                  isSubmitting
                }
                className='bg-green-50 w-full h-[44px] text-green-700 text-base font-medium mb-4 rounded-lg	shadow-sm border border-green-50'
              >
                { (caseNotesCreateLoading || isSubmitting) && (
                  <Loader cssClass='text-black' isSmallView />
                )}
                Create
              </button>
              <button
                type='button'
                onClick={handleCancelCaseNote}
                className='bg-gray-200 w-full h-[44px] text-gray-400 text-base font-medium rounded-lg	shadow-sm border-gray-200'
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
export default CreateCaseNotesModal;
